import axios from "axios";
import { geoServerBaseUrl } from "./baseUrl";
import his from "./history";
import { snackbar } from "./snackbarActions";

const SERVER_URL = geoServerBaseUrl;

/*NON API*/

/*GET METHODE*/

/**
 * @name : verify_license_user
 * @endpoint : /license/verify_license_user
 * @methode : get
 */
export const verify_license_user = () => async (dispatch) => {
  try {
    if (localStorage.token_mapid) {
      dispatch({
        type: "set_loading_action",
        payload: "verify_license_user",
      });
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };
      const res = await axios.get(
        SERVER_URL + `/license/verify_license_user`,
        config,
      );

      if (
        ["license_2", "license_3"].includes(res?.data?.payment_type) &&
        res?.data?._id
      ) {
        dispatch(get_collaborator(res?.data?._id));
      }

      dispatch({
        type: "set_value_license",
        payload: {
          key: "license_user_status",
          value: res.data,
        },
      });

      dispatch({
        type: "clear_loading_action",
        payload: "verify_license_user",
      });
      return res.data;
    }
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "verify_license_user",
    });
  }
};

/**
 * @name : verify_license
 * @param {String} license_type - jenis license_typenya
 * @endpoint : /license/verify_license
 * @methode : get
 */
export const verify_license = (license_type) => async (dispatch) => {
  try {
    if (localStorage.token_mapid) {
      dispatch({
        type: "set_loading_action",
        payload: "verify_license",
      });
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };
      const res = await axios.get(
        SERVER_URL + `/license/verify_license?license_type=${license_type}`,
        config,
      );

      if (
        ["team", "enterprise"].includes(res?.data?.payment_type) &&
        license_type === "license_basic" &&
        res?.data?._id
      ) {
        dispatch(get_collaborator(res?.data?._id));
      }

      dispatch({
        type: "set_value_license",
        payload: {
          key: license_type,
          value: res.data,
        },
      });

      dispatch({
        type: "clear_loading_action",
        payload: "verify_license",
      });
      return res.data;
    }
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "verify_license",
    });
  }
};

export const optimized_get_user_license = () => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "optimized_get_user_license",
    });

    let new_licenses = [];
    const license_keys = [
      "license_basic",
      "license_sini_ai",
      "license_sini_data",
    ];

    let shortest_license_key = {
      active_days: null,
      license_key: "",
    };

    const old = await dispatch(verify_license_user());
    if (!old?.is_has_license) {
      for (let license_key of license_keys) {
        const license = await dispatch(verify_license(license_key));
        new_licenses.push({ ...license, license_key });

        //ambil license yang masih aktif dan paling sedikit masa aktifnya
        if (
          license?.active_days > 0 &&
          license?.is_has_license &&
          (license?.active_days < shortest_license_key?.active_days ||
            !shortest_license_key?.active_days)
        ) {
          shortest_license_key.active_days = license?.active_days;
          shortest_license_key.license_key = license_key;
        }
      }

      if (shortest_license_key?.license_key) {
        if (
          shortest_license_key?.active_days > 0 &&
          shortest_license_key?.active_days <= 5
        ) {
          dispatch(
            snackbar({
              is_open: true,
              status: "warning",
              message: `Your license will expire in ${shortest_license_key?.active_days} days. `,
            }),
          );
        }
      }
    } else {
      if (old?.active_days > 0 && old?.active_days <= 5) {
        dispatch(
          snackbar({
            is_open: true,
            status: "warning",
            message: `Your license will expire in ${old?.active_days} days. `,
          }),
        );
      }
    }

    const group = await dispatch(verify_license_group());

    if (!group?.is_has_license) {
      dispatch(verify_license_sharing());
    }

    dispatch({
      type: "clear_loading_action",
      payload: "optimized_get_user_license",
    });
  } catch (e) {
    dispatch({
      type: "clear_loading_action",
      payload: "optimized_get_user_license",
    });
  }
};

/**
 * @name : verify_license_team
 * @methode : get
 */
export const verify_license_sharing = () => async (dispatch) => {
  try {
    if (localStorage.token_mapid) {
      dispatch({
        type: "set_loading_action",
        payload: "verify_license_sharing",
      });
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };
      const res = await axios.get(
        SERVER_URL + `/license/verify_license_sharing`,
        config,
      );
      dispatch({
        type: "set_value_license",
        payload: {
          key: "license_sharing",
          value: res.data,
        },
      });
      dispatch({
        type: "clear_loading_action",
        payload: "verify_license_sharing",
      });

      if (res?.data?._id) await dispatch(get_collaborator(res.data._id));
    }
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "verify_license_sharing",
    });
  }
};

/**
 * @name : verify_license_group
 * @endpoint : /license/verify_license_group
 * @methode : get
 */
export const verify_license_group = () => async (dispatch) => {
  try {
    if (localStorage.token_mapid) {
      dispatch({
        type: "set_loading_action",
        payload: "verify_license_group",
      });
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };
      const res = await axios.get(
        SERVER_URL + `/license/verify_license_group`,
        config,
      );
      dispatch({
        type: "set_value_license",
        payload: {
          key: "license_group_status",
          value: res.data,
        },
      });
      dispatch({
        type: "clear_loading_action",
        payload: "verify_license_group",
      });

      if (res?.data?._id) await dispatch(get_collaborator(res.data._id));

      return res.data;
    }
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "verify_license_group",
    });
  }
};

/*POST METHODE*/

/**
 * @name : create_group_family
 * @endpoint : /groups_new/create_group_family
 * @methode : post
 */
export const create_group_family = (body) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "create_group_family",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const res = await axios.post(
      SERVER_URL + `/groups_new/create_group_family`,
      body,
      config,
    );
    dispatch({
      type: "set_value_license",
      payload: {
        key: "group_family",
        value: res.data,
      },
    });
    dispatch({
      type: "clear_loading_action",
      payload: "create_group_family",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "create_group_family",
    });
  }
};

/** ❤️❤️❤️❤️AKU SUKA NGODING. ga ketang */

/**
 * @name : add_collaborator
 * @endpoint : /collaborators/add_collaborator
 * @methode : post
 */
export const add_collaborator =
  (
    body,
    collaborators,
    current_collaborator_qty,
    collaborator_qty,
    p_id,
    payment_type,
  ) =>
  async (dispatch, getState) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };

      // STEP 1: Cek apakah dia owner grup
      const official_account = await axios.post(
        SERVER_URL + `/collaborators/is_official_account`,
        body,
        config,
      );

      const is_official = official_account.data.is_official;
      const owner = await axios.post(
        SERVER_URL + `/collaborators/find_owner`,
        body,
        config,
      );
      const is_owner = owner.data.find_owner !== null;

      // STEP 2: Cek apakah dia member grup lain
      const member_col = await axios.post(
        SERVER_URL + `/collaborators/find_member`,
        body,
        config,
      );
      const is_member = member_col.data.collaborator.length > 0;

      // STEP 3: Tambahkan jika dia bukan owner & bukan member
      if ((!is_owner && !is_member) || is_official) {
        const alreadyInList = collaborators.some(
          (collab) => collab._id === body._id,
        );

        if (
          !alreadyInList &&
          current_collaborator_qty < parseInt(collaborator_qty - 1) &&
          ["license_2", "team"].includes(payment_type)
        ) {
          await axios.post(
            SERVER_URL + `/collaborators/add_collaborator`,
            { ...body, payment_id: p_id },
            config,
          );
          dispatch({
            type: "push_value_auth",
            payload: {
              key: "collaborators",
              value: body,
            },
          });

          dispatch({
            type: "set_value_auth",
            payload: {
              key: "current_collaborator_qty",
              value: collaborators.length + 1,
            },
          });
        } else if (
          !alreadyInList &&
          ["license_3", "enterprise"].includes(payment_type)
        ) {
          await axios.post(
            SERVER_URL + `/collaborators/add_collaborator`,
            { ...body, payment_id: p_id },
            config,
          );
          dispatch({
            type: "push_value_auth",
            payload: {
              key: "collaborators",
              value: body,
            },
          });

          dispatch({
            type: "set_value_auth",
            payload: {
              key: "current_collaborator_qty",
              value: collaborators.length + 1,
            },
          });
        } else if (alreadyInList) {
          dispatch(
            snackbar({
              is_open: true,
              status: "warning",
              message: "User already in list",
            }),
          );
        } else {
          dispatch(
            snackbar({
              is_open: true,
              status: "error",
              message:
                "Collaboration limit reached. Please upgrade your quota to add more members.",
            }),
          );
        }
      } else {
        dispatch(
          snackbar({
            is_open: true,
            status: "error",
            message: "cannot add this member",
          }),
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

/**
 * @name : get_collaborator
 * @endpoint :/collaborators/get_collaborator/:payment_id
 * @methode : get
 */
export const get_collaborator = (p_id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_collaborator",
    });

    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    const collaborators = await axios.get(
      SERVER_URL + `/collaborators/get_collaborator/${p_id}`,
      config,
    );

    if (collaborators?.data?.members?.length > 0) {
      const coll = collaborators.data?.members?.map((dt) => {
        return {
          ...dt.user,
          _id: dt.id_user,
        };
      });
      let pending_collaborators = collaborators.data.members_pending;

      const updated_pending_collaborators = pending_collaborators.map((dt) => {
        return { ...dt, collaborators_id: collaborators.data._id };
      });

      dispatch({
        type: "set_value_auth",
        payload: {
          key: "collaborators",
          value: coll,
        },
      });
      dispatch({
        type: "set_value_auth",
        payload: {
          key: "pending_collaborators",
          value: updated_pending_collaborators,
        },
      });
    }

    dispatch({
      type: "clear_loading_action",
      payload: "get_collaborator",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_collaborator",
    });

    console.error(error);
  }
};

/**
 * @name : delete_collaborator
 * @endpoint : /collaborators/delete_collaborator
 * @methode : post
 */
export const delete_collaborator =
  (body, collaborator, p_id) => async (dispatch, getState) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };

      await axios.post(
        SERVER_URL + `/collaborators/delete_collaborator`,
        { ...body, payment_id: p_id },
        config,
      );

      dispatch({
        type: "delete_value_auth",
        payload: {
          key: "collaborators",
          value: body,
        },
      });

      dispatch({
        type: "set_value_auth",
        payload: {
          key: "current_collaborator_qty",
          value: collaborator.length - 1,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

/**
 * @name : invite_collaborator
 * @endpoint : /collaborators/invite_collaborator
 * @methode : post
 */
export const invite_collaborator =
  (payment_id, user_pending, via, lang) => async (dispatch, getState) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };

      const domain = window.location.origin;
      let body = { payment_id, user_pending, via, lang, domain };

      await axios.post(SERVER_URL + `/mail/invite_collab`, body, config);

      // dispatch({
      //   type: "push_value_auth",
      //   payload: {
      //     key: "pending_collaborators",
      //     value: body,
      //   },
      // });
      dispatch(
        snackbar({
          is_open: true,
          status: "success",
          message: "Your profile was successfully invited",
        }),
      );
    } catch (error) {
      console.error(error);
      dispatch(
        snackbar({
          is_open: true,
          status: "error",
          message:
            error?.response?.data?.message ||
            "Failed to invite user already exist",
        }),
      );
    }
  };

/**
 * @name : cancel_invite_collaborator
 * @endpoint : /collaborators/invite_collaborator
 * @methode : post
 */
export const cancel_invite_collaborator =
  (collaborators_id, phone_number, email, _id) =>
  async (dispatch, getState) => {
    try {
      const config = {
        headers: {
          accesstoken: localStorage.token_mapid,
        },
      };

      await axios.post(
        SERVER_URL + `/collaborators/cancel_invitation`,
        { collaborators_id, _id },
        config,
      );

      dispatch({
        type: "delete_value_auth",
        payload: {
          key: "pending_collaborators",
          value: { collaborators_id, phone_number, email, _id },
        },
      });
    } catch (error) {
      console.error(error);
    }
  };
/**
 * @name : join_collab_by_accesstoken
 * @endpoint : /collaborators/join_collab_by_accesstoken
 * @methode : post
 */
export const join_collab_by_accesstoken = (body) => async (dispatch) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    // STEP 1: Cek apakah dia owner grup
    const owner = await axios.post(
      SERVER_URL + `/collaborators/find_owner`,
      body,
      config,
    );
    const is_owner = owner.data.find_owner !== null;

    // STEP 2: Cek apakah dia member grup lain
    const member_col = await axios.post(
      SERVER_URL + `/collaborators/find_member`,
      body,
      config,
    );
    const is_member = member_col.data.collaborator.length > 0;

    let res;

    // STEP 3: Tambahkan jika dia bukan owner & bukan member
    if (!is_owner && !is_member) {
      res = await axios.post(
        SERVER_URL + `/collaborators/join_collab_by_accesstoken`,
        body,
        config,
      );

      dispatch(verify_license_sharing());
    } else {
      his.push("/dashboard");
    }

    if (res.status === 200) his.push("/dashboard");
  } catch (error) {
    console.error(error);
  }
};

export const invite_via_link = (payment_id) => async (dispatch, getState) => {
  try {
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    const domain = window.location.origin;
    const body = { payment_id, domain };
    const res = await axios.post(
      SERVER_URL + `/collaborators/generate_link_public_collab`,
      body,
      config,
    );

    dispatch({
      type: "set_value_auth",
      payload: {
        key: "link_invitation",
        value: res.data.message,
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const check_collaborators =
  (collab_code) => async (dispatch, getState) => {
    try {
      let config = {};
      const accesstoken = localStorage.token_mapid;
      if (accesstoken) {
        config.headers = {
          accesstoken: localStorage.token_mapid,
        };
      }

      const res = await axios.get(
        SERVER_URL + `/collaborators/is_member_full/${collab_code}`,
        config,
      );

      return res.data;
    } catch (error) {
      console.error(error);
    }
  };
